import { string, shape, number, arrayOf } from 'prop-types';

const registeredBusPropTypes = {
  id: number,
  companyBusId: string,
};

const driverTypePropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  description: string,
};

const driverPropTypes = {
  driverId: number.isRequired,
  driverName: string.isRequired,
  driverIdDocumentNumber: string.isRequired,
  driverType: shape(driverTypePropTypes),
};

const maintenanceFailModePropTypes = {
  description: string,
};

const activityPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  companyActivityId: string,
};

const checklistActivityPropTypes = {
  id: number.isRequired,
  maintenanceChecklistId: number.isRequired,
  maintenanceFailModeId: number.isRequired,
  maintenanceFailMode: shape(maintenanceFailModePropTypes),
  maintenanceFailModeCategoryId: number,
  maintenanceFailModeCategory: shape({}),
  activityId: number.isRequired,
  activity: shape(activityPropTypes),
  comment: string,
};

const maintenanceChecklistPropTypes = {
  id: number.isRequired,
  serviceOrderId: number.isRequired,
  registeredBusId: number.isRequired,
  registeredBus: shape(registeredBusPropTypes),
  deadLine: number.isRequired,
  driverId: number,
  driver: shape(driverPropTypes),
  maintenanceChecklistActivityList: arrayOf(shape(checklistActivityPropTypes)),
};

const maintenanceChecklistDefaultProps = {
  driverId: null,
  driver: null,
  registeredBus: null,
  maintenanceChecklistActivityList: [],
};

const maintenanceChecklistActivityListPropTypes = {
  maintenanceChecklistActivityList: arrayOf(shape(checklistActivityPropTypes)),
};

const maintenanceChecklistActivityListDefaultProps = {
  maintenanceChecklistActivityList: [],
};

const registeredBusDefaultProps = {
  id: null,
  companyBusId: null,
};

const driverTypeDefaultProps = {
  description: null,
};

const checklistActivityDefaultProps = {
  maintenanceFailMode: null,
  maintenanceFailModeCategoryId: null,
  maintenanceFailModeCategory: null,
  activity: null,
  comment: null,
};

export {
  maintenanceChecklistPropTypes,
  maintenanceChecklistDefaultProps,
  maintenanceChecklistActivityListPropTypes,
  maintenanceChecklistActivityListDefaultProps,
  registeredBusPropTypes,
  registeredBusDefaultProps,
  driverPropTypes,
  driverTypePropTypes,
  driverTypeDefaultProps,
  maintenanceFailModePropTypes,
  activityPropTypes,
  checklistActivityPropTypes,
  checklistActivityDefaultProps,
};
